/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Row, Col, Image, Space } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box, Typography } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { ListTable } from './ListTable';
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';


const RejectReason = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const { rejectDetails, rejectLoader } = useSelector(state => state.younoteAdminSetupReducer);
    const { editDetails, editError, editLoader, createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const { history } = props;
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [addMore, setAddMore] = useState(false);
    const [view, setView] = useState(false);
    const [error, setError] = useState({});
    const [form, setForm] = useState({});
    const [visible, setVisible] = useState(false);
    const [rejectId, setRejectId] = useState('');
    const [importVisible, setImportVisible] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [code, setCode] = useState('');

    const dispatch = useDispatch();

    const handleAddMore = (e) => {
        createReasons(e);
        setAddMore(true);
    }

    const handleOpen = () => {
        setRejectId('');
        setVisible(true);
        emptyState();
        emptyStateInput();
    }

    const emptyState = () => {
        setError({});
    }
    const emptyStateInput = () => {
        setForm({
            "rejectReasonCode": '',
            "rejectReasonDesc": ''
        });
    };

    const handleAdd = () => {
        setView(false);
        handleOpen();
    }

    const onExport = () => {
        loadImportExportData('RejectCodes');
    }

    const onEdit = (data) => {
        setView(false);
        handleOpen();
        setRejectId(data.id);
        setForm({
            "rejectReasonCode": data?.rejectReasonCode,
            "rejectReasonDesc": data?.rejectReasonDesc
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setRejectId(data.id);
        setCode(data.rejectReasonCode);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.REJECT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            if (text.includes("UNIVERSL_PRODUCT_ID_UNIQUE")) {
                setError({
                    ...error,
                    "rejectReasonCode": "ProductId already exits"
                })
            }
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Reason Codes', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const changeHandler = (e, name = '') => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            if (text.includes("UNIVERSL_PRODUCT_ID_UNIQUE")) {
                setError({
                    ...error,
                    "rejectReasonCode": "Reject codes already exits"
                })
            }
        }
    }, [editDetails, editError]);


    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ rejectReasonCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ rejectReasonDesc: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'reject-reasons',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const createReasons = (e) => {
        e.preventDefault();
        let emptyCodes = emptyValidation('Reason Codes Code', form.rejectReasonCode);
        emptyState();
        if (emptyCodes.isValid) {
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            dispatch({
                type: rejectId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "reject-reasons",
                title: "reject-reasons",
                id: rejectId,
                details: data
            })
        } else {
            setError({
                'rejectReasonCode': emptyCodes.errors,
            });
        }
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onView = (data) => {
        setView(true);
        handleOpen();
        setRejectId(data.id);
        setForm({
            "rejectReasonCode": data?.rejectReasonCode,
            "rejectReasonDesc": data?.rejectReasonDesc
        });
    }


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Reason Codes', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Reason Codes'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Reason Codes', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center" >
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Reason Codes', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleAdd()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    />
                                                     <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Reason Codes</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Reason Codes', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Reason Codes', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onView={(data) => onView(data)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${rejectId ? `${view ? 'View' : 'Edit'}` : 'Add'} Reason Codes`}
                width={'360px'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createReasons(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Reason Codes Code</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.rejectReasonCode}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Reason Codes Code ", <span key={"Reason Codes Code"} className={classes.colorRedRequired}> *</span>]}
                                                variant={'standard'}
                                                error={error.rejectReasonCode ? true : false}
                                                helperText={error.rejectReasonCode}
                                                name={"rejectReasonCode"}
                                                fullWidth
                                                value={form.rejectReasonCode}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.rejectReasonDesc}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label='Description'
                                                name={"rejectReasonDesc"}
                                                value={form.rejectReasonDesc}
                                                multiline
                                                variant="outlined"
                                                fullWidth
                                                className={clsx(classes.margin30t, classes.customDescription)}
                                                rows={3}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColor,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                rejectId ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !rejectId &&
                                            <Button
                                                key="save"
                                                color="primary"
                                                variant="contained"
                                                onClick={(e) => handleAddMore(e)}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >Add More</Button>
                                        }
                                    </Space> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                            }
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'RejectCodes'}
                type={"import"}
                details={rejectDetails}
                loader={rejectLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder); }}
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={rejectId} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={code} url={'reject-reasons'}
                title={'Reason Codes'} visible={deleteModal} />
        </React.Fragment>
    );
}

export default RejectReason